<template>
  <el-container direction="vertical">
    <v-head></v-head>
    <el-container>
      <v-sidebar></v-sidebar>
      <el-main>
        <transition name="move" mode="out-in">
          <!-- <keep-alive> -->
          <router-view></router-view>
          <!-- </keep-alive> -->
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import vHead from '@/pages/common/Header.vue';
import vSidebar from '@/pages/common/Sidebar.vue';
export default {
  components:{
    vHead,
    vSidebar
  },
}
</script>

<style>
  .el-header, .el-footer {
    /* background-color: #E9EEF3; */
    color: #333;
    text-align: center;
    line-height: 60px;
    border-bottom: 1px solid #999;
  }

  .el-aside {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  
  .el-menu {
    background-color: #E9EEF3;
    color: #333;
  }

  .el-pagination {
    padding: 20px 5px;
  }

  #app > .el-container {
    box-sizing: border-box;
    height: 100%;
    padding-bottom: 40px;
  }
</style>